import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const discountFilterLabel = () => t({ message: 'Discount', comment: 'Insights: Discount filter' });
export function DiscountFilter() {
    return <BooleanFilter name="metadataDocumentDiscount" label={discountFilterLabel()}/>;
}
